module.exports = __webpack_public_path__ + "img/18_nakamichi_plugs.cc9d24c7.jpg";